export enum BuildingType {
    OUTDOOR = 'outdoor',
}

export enum BuildingNameType {
    MALL = 'MALL',
    OUTLET = 'OUTLET',
    PREMIUM_OUTLET = 'PREMIUM_OUTLET',
    AVENUEL = 'AVENUEL',
    YOUNG_PLAZA = 'YOUNG_PLAZA',
    SHOPPING_MALL = 'SHOPPING_MALL',
}
